<div class="iss-global-error-page-up"></div>
<div class="iss-global-error-page-center">
  <div class="iss-global-error-page-title">Something went wrong...</div>
  <div class="iss-global-error-page-msg">The app could not be started. Try again later.</div>
  <button tuiButton (click)="reload()">Reload</button>
</div>
<div class="iss-global-error-page-down"></div>
